import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
// import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
// Chart.register(ArcElement, Tooltip, Legend);
ChartJS.register(ArcElement, Tooltip, Legend);

const Navbar = () => {

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-black border-b border-blue-400 shadow-md sticky top-0 z-50">
      <div className="mx-auto px-2 py-3 flex flex-row justify-between">
        <div className="flex items-center gap-2 h-12">
          <div className="h-full flex items-center">
            <img
              src="/assets/banners/lensshoplogo.jpg"
              alt="LensShop AI Logo"
              className="h-10 w-auto"
            />
          </div>  
          <div className="h-full flex flex-col justify-center leading-tight">
            <h1 className="text-lg lg:text-xl font-bold text-yellow-200">
              LensShop AI
            </h1>            
            <h2 className="text-xs lg:text-sm font-bold text-white">
              नज़र साफ़। भरोसा पक्का।
            </h2>  
          </div>
        </div>

        <div className="p-2 flex rounded">
          <div className="flex items-center gap-3">
            {isLoggedIn ? (
              <>
                <div className="text-xs lg:text-sm text-teal-300">
                  {userName}
                </div>

                <button
                  onClick={handleLogout}
                  className="p-1 w-6 text-xs lg:text-sm rounded-md
                            bg-red-600 hover:bg-red-700 transition"
                  title="Logout"
                >
                  ⏻
                </button>
              </>
            ) : (
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700
                          text-xs lg:text-sm text-gray-200 hover:bg-gray-800"
              >
                🔑
              </button>
            )}
          </div>
        </div>

      </div>
    </nav>
  );
};

const TopNav = () => {
  return (
    <section
      id="home"
      className="flex flex-col lg:flex-row lg:justify-between px-4 text-white relative bg-black py-0 gap-1 mt-2 mb-1"
    >
      <div className="w-full">
        <ul className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-8 gap-0.5">

           <li>
             <Link
              to="/eyewear-record-list"
              className="w-full bg-blue-900 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🧿</span>
              <span>Eyewear Routine</span>
            </Link>
          </li>

          <li>
            <Link
              to="/besure-home"
              className="w-full bg-blue-900 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🛡️</span>
              <span>beSure Quality</span>
            </Link>
          </li>

          <li>
            <Link
              to="/orderflow-products/lensshop"
              className="w-full bg-blue-800 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🌍</span>
              <span>World of Lenses</span>
            </Link>
          </li>

          <li>
            <Link
              to="/orderflow-products/lensshop/frames"
              className="w-full bg-blue-800 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">👓</span>
              <span>World of Frames</span>
            </Link>
          </li>

          <li>
             <Link
              to="/orderflow-products/lensshop/hero"
              className="w-full bg-blue-800 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">⭐</span>
              <span>Hero Products</span>
            </Link>
          </li>

          <li>
            <Link
              to="/orderflow-products/lensshop/hero"
              className="w-full bg-blue-800 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🔥</span>
              <span>Trending</span>
            </Link>
          </li>          

          <li>
            <Link
              to="/orderflow-products/lensshop/essentials"
              className="w-full bg-blue-800 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🧩</span>
              <span>Essentials</span>
            </Link>
          </li>

          <li>
            <Link
              to=""
              className="w-full bg-blue-800 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">📍</span>
              <span>Nearby</span>
            </Link>
          </li>   

          <li>
             <Link
              to="/bolograhak-home"
              className="w-full bg-blue-700 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🛟</span>
              <span>boloGrahak</span>
            </Link>
          </li>                 

          <li>
             <Link
              to="/packetpulse-home"
              className="w-full bg-blue-700 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🚛</span>
              <span>My Packet</span>
            </Link>
          </li>

          <li>
            <a
              href="#personalize"
              className="w-full bg-blue-900 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🎨</span>
              <span>Personalize</span>
            </a>
          </li>

          <li>
            <Link
              to="/agenticsim"
              className="w-full bg-cyan-700 hover:bg-cyan-900 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🤖</span>
              <span>LensShop AI</span>
            </Link>
          </li>

          <li>
            <Link
              to="/twiworld"
              className="w-full bg-cyan-700 hover:bg-cyan-900 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🌐</span>
              <span>LensShop Twin</span>
            </Link>
          </li>
          
          <li>
            <Link
              to="/photocanwin"
              className="w-full bg-teal-600 hover:bg-teal-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">😎</span>
              <span>Win Photo Smart</span>
            </Link>
          </li>

          <li>
            <Link
              to="/kharchojeeto"
              className="w-full bg-teal-600 hover:bg-teal-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🪞</span>
              <span>KharchoJeeto</span>
            </Link>
          </li>       

          <li>
            <Link
              to="/orderflow-earning-estimator"
              className="w-full bg-cyan-600 hover:bg-cyan-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">💰</span>
              <span>Digital Income</span>
            </Link>
          </li>   

          <li>
            <Link
              to="/bookshelf"
              className="w-full bg-cyan-600 hover:bg-cyan-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">📖</span>
              <span>Monthly EyeGyan</span>
            </Link>
          </li>              

          <li>
            <Link
              to=""
              className="w-full bg-blue-600 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🧑‍💼</span>
              <span>My Account</span>
            </Link>
          </li>   

          <li>
            <a
              href="#features"
              className="w-full bg-blue-700 hover:bg-blue-900 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">✨</span>
              <span>Features</span>
            </a>
          </li>
          
          <li>
            <a
              href="#engine"
              className="w-full bg-blue-700 hover:bg-blue-900 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🚀</span>
              <span>Get Started</span>
            </a>
          </li> 

          <li>
            <Link
              to=""
              className="w-full bg-blue-600 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">⋯</span>
              <span>more</span>
            </Link>
          </li> 

        </ul>
      </div>     
    </section>
  );
};
      
const Hero = () => {
  return (
    <section
      id="home"
      className="flex flex-col items-center justify-center h-[30vh] md:h-[40vh] lg:h-[50vh] px-4 ml-4 mr-4 text-white text-center relative
                bg-gradient-to-r from-blue-600 via-cyan-500 to-purple-600"
    >    
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/70 to-cyan-400/70"></div>
      <div className="relative z-10">
        <div className='flex flex-row justify-center items-center'>
          <img src="/assets/banners/lensshoplogo.jpg" alt="LensShop AI Logo" className="h-10 w-auto mr-4"/>
          <h1 className="text-2xl lg:text-4xl font-bold text-yellow-200">LensShop AI</h1>   
        </div>
        <h1 className="text-lg lg:text-2xl font-bold mb-4 text-white">Pehle Pehno, Phir Bharosa Karo! Ghar Baithe</h1>
        <p className="text-sm lg:text-lg mb-6 text-yellow-300">Personalized glasses tailored to your style, fit and vision needs.</p>
        <a href="#personalize" className="px-6 py-3 bg-cyan-700 text-white rounded-md font-semibold hover:bg-cyan-900 hover:text-yellow-200 z-10">
          Get Personalized Fit
        </a>
      </div>
    </section>
  );
};


const getScoreMeta = (score) => {
  if (score >= 90) return { label: "Excellent", color: "#16a34a" };
  if (score >= 70) return { label: "Good", color: "#22c55e" };
  if (score >= 50) return { label: "Needs Care", color: "#eab308" };
  return { label: "High Risk", color: "#dc2626" };
};

const ScoreChart = ({ score, chartRef }) => {
  const meta = getScoreMeta(score);

  const data = {
    labels: ["Wellness Score", "Remaining"],
    datasets: [
      {
        data: [score, 100 - score],
        backgroundColor: [meta.color, "#1f2937"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    plugins: { legend: { display: false } },
    cutout: "70%",
  };

  return (
    <div className="relative w-48 h-48 mx-auto">
      <Pie data={data} options={options} />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
        <div className="text-2xl font-bold">{score}%</div>
        <div className="text-xs text-gray-300">{meta.label}</div>
      </div>
    </div>
  );
};

const getWellnessInsights = (score) => {
  if (score >= 90) {
    return {
      label: "Excellent Eye Health",
      color: "text-green-400",
      message: "Your eyes are in great shape! Maintain these healthy habits.",
      tasks: [
        { emoji: "👀", text: "Blink consciously while working on screens." },
        { emoji: "🕶️", text: "Continue using UV-protective eyewear outdoors." },
        { emoji: "📅", text: "Schedule a routine eye check-up once a year." },
      ],
    };
  }

  if (score >= 70) {
    return {
      label: "Good, With Minor Strain",
      color: "text-lime-400",
      message: "Your eyes are doing well, but a little extra care will help.",
      tasks: [
        { emoji: "⏱️", text: "Follow the 20-20-20 rule during screen use." },
        { emoji: "💆‍♂️", text: "Do a 1-minute eye massage daily." },
        { emoji: "💧", text: "Keep your eyes hydrated and avoid dryness." },
      ],
    };
  }

  if (score >= 50) {
    return {
      label: "Eye Strain Detected",
      color: "text-yellow-400",
      message: "Your eyes are under noticeable strain. Take corrective steps.",
      tasks: [
        { emoji: "🖥️", text: "Reduce continuous screen exposure." },
        { emoji: "👓", text: "Consider blue-light or anti-glare lenses." },
        { emoji: "😴", text: "Ensure proper sleep for eye recovery." },
      ],
    };
  }

  return {
    label: "High Eye Stress Risk",
    color: "text-red-400",
    message: "Your eye health needs immediate attention.",
    tasks: [
      { emoji: "🚨", text: "Limit screen usage as much as possible." },
      { emoji: "👁️‍🗨️", text: "Consult an eye specialist soon." },
      { emoji: "🛑", text: "Avoid night driving without proper lenses." },
    ],
  };
};

const VisionProfile = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const userName = authState?.user?.name || "User";

  // Dummy / example state
  const [dailyScore, setDailyScore] = useState(75); // Daily Eye Wellness Score
  const [streak, setStreak] = useState(5); // Consecutive days
  const [nextExpiry, setNextExpiry] = useState(90); // Days until prescription expires
  const [tipOfTheDay, setTipOfTheDay] = useState(
    "Follow the 20-20-20 rule while using screens."
  );

  const visionData = {
    labels: ["Left Eye", "Right Eye", "Remaining Wellness"],
    datasets: [
      {
        label: "Eye Health Score",
        data: [40, 35, 25],
        backgroundColor: ["#3B82F6", "#FBBF24", "#6B7280"],
        borderWidth: 1,
      },
    ],
  };

  const pieOptions = {
    responsive: true,
    plugins: {
      legend: { position: "bottom", labels: { color: "white" } },
    },
  };

  return (
    <section className="py-2 bg-black text-center px-4 max-w-5xl mx-auto space-y-8">
      <h2 className="text-lg lg:text-xl font-bold text-yellow-200">
        Hey {userName}, here's your Vision Profile 👁️
      </h2>

      {/* Eye Score + Pie Chart */}
      <div className="flex flex-col lg:flex-row items-center justify-center gap-6 bg-gray-900 p-6 rounded-2xl border border-gray-700">
        <div className="w-48 h-48 mx-auto lg:mx-0">
          <Pie data={visionData} options={pieOptions} />
        </div>

        <div className="flex flex-col gap-4 text-left text-white max-w-md">
          <p className="text-sm lg:text-lg text-white font-semibold">
            Eye Wellness Score:
            <span className="text-yellow-400 ml-2">{dailyScore}/100</span>
          </p>
          <p className="text-sm lg:text-lg text-white">
            Routine: <span className="text-green-400 font-bold">{streak} days</span>
          </p>
          <p className="text-sm lg:text-lg text-white">
            Prescription expires in:{" "}
            <span
              className={nextExpiry <= 30 ? "text-red-500 font-bold" : "text-cyan-400"}
            >
              {nextExpiry} days
            </span>
          </p>
          <p className="text-sm lg:text-lg italic text-white">
            Tip of the day: {tipOfTheDay}
          </p>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="flex flex-row justify-center gap-4">
        <button className="bg-blue-600 hover:bg-blue-700 text-xs lg:text-lg px-2 py-2 rounded-lg text-white font-semibold transition">
          Update Prescription
        </button>
        <button className="bg-green-600 hover:bg-green-700 text-xs lg:text-lg px-2 py-2 rounded-lg text-white font-semibold transition">
          Do Daily Exercise
        </button>
        <button className="bg-yellow-600 hover:bg-yellow-700 text-xs lg:text-lg px-2 py-2 rounded-lg text-white font-semibold transition">
          Track Eye Score
        </button>
      </div>

      {/* Lens & Fit Details */}
      <div className="bg-gray-800 border border-gray-700 rounded-2xl p-6 text-left space-y-3 max-w-md mx-auto">
        <h3 className="text-sm lg:text-lg font-semibold text-cyan-400">Lens Details & Fit</h3>
        <p className="text-white text-sm lg:text-lg">
          <span className="font-semibold">Prescription:</span> -2.5 (Left), -2.0 (Right)
        </p>
        <p className="text-white text-sm lg:text-lg">
          <span className="font-semibold">Lens Type:</span> Anti-Reflective
        </p>
        <p className="text-white text-sm lg:text-lg">
          <span className="font-semibold">Fit Preference:</span> Medium Frames
        </p>
      </div>

      {/* Streak & Engagement Bar */}
      <div className="bg-gray-900 p-2 rounded-2xl border border-gray-700 max-w-md mx-auto">
        <p className="text-white mb-2 font-semibold text-sm lg:text-lg">🔥 Your Eye Health Routine </p>
        <div className="w-full bg-gray-700 h-5 rounded-full">
          <div
            className="bg-yellow-400 h-5 rounded-full transition-all text-white"
            style={{ width: `${Math.min(streak * 10, 100)}%` }}
          ></div>
        </div>
      </div>
    </section>
  );
};

const PersonalizationPreview = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const userName = authState?.user?.name || "User";
  const chartRef = useRef(null);

  const [language, setLanguage] = useState("en");
  const [answers, setAnswers] = useState([]);
  const [score, setScore] = useState(null);

  // English Data
  const stepsEn = [
    { emoji: "🧑‍🤝‍🧑", title: "Step 1: Demographics", desc: "Enter age, gender, and occupation." },
    { emoji: "🤳", title: "Step 2: Face Shape Detection", desc: "Upload a selfie for AI analysis." },
    { emoji: "👓", title: "Step 3: Frame Selection", desc: "Choose shape, color, size, weight, and material." },
    { emoji: "🔬", title: "Step 4: Lens Selection", desc: "Select power, type, thickness, and coatings." },
    { emoji: "🛒", title: "Step 5: Preview & Add to Cart", desc: "See your custom glasses and add to cart." },
  ];

  const questionsEn = [
    { emoji: "💻", text: "How often do you use digital screens?", options: ["Rarely", "1–3 hrs/day", "3–6 hrs/day", "6+ hrs/day"], type: "single", score: [20, 15, 10, 5] },
    { emoji: "🌙", text: "Do you drive at night?", options: ["Yes", "No"], type: "single", score: [5, 15] },
    { emoji: "👁️", text: "Any specific vision issues?", options: ["Near-sighted", "Far-sighted", "Astigmatism", "None"], type: "multi", score: [5, 5, 5, 20] },
    { emoji: "🔍", text: "Preferred lens type?", options: ["Standard", "Blue Light", "Photochromic", "Progressive"], type: "single", score: [10, 15, 15, 20] },
    { emoji: "💰", text: "Budget range?", options: ["₹0–₹1,000", "₹1,000–₹3,000", "₹3,000–₹7,000", "₹7,000+"], type: "single", score: [10, 15, 20, 20] },
  ];

  const tasksEn = [
    { emoji: "👀", text: "Blink 20 times in a row." },
    { emoji: "⏱️", text: "Look away from your screen for 20 seconds." },
    { emoji: "💆‍♂️", text: "Do a 1-minute eye massage." },
  ];

  // Hindi Data
  const stepsHi = [
    { emoji: "🧑‍🤝‍🧑", title: "चरण 1: जनसांख्यिकी", desc: "अपनी उम्र, लिंग, और पेशा दर्ज करें।" },
    { emoji: "🤳", title: "चरण 2: चेहरे का आकार पहचान", desc: "AI विश्लेषण के लिए एक सेल्फी अपलोड करें।" },
    { emoji: "👓", title: "चरण 3: फ़्रेम चयन", desc: "आकार, रंग, आकार, वजन और सामग्री चुनें।" },
    { emoji: "🔬", title: "चरण 4: लेंस चयन", desc: "पावर, प्रकार, मोटाई और कोटिंग चुनें।" },
    { emoji: "🛒", title: "चरण 5: पूर्वावलोकन और कार्ट में जोड़ें", desc: "अपने कस्टम चश्मे देखें और कार्ट में जोड़ें।" },
  ];

  const questionsHi = [
    { emoji: "💻", text: "आप डिजिटल स्क्रीन का उपयोग कितनी बार करते हैं?", options: ["कभी-कभार", "1–3 घंटे/दिन", "3–6 घंटे/दिन", "6+ घंटे/दिन"], type: "single", score: [20, 15, 10, 5] },
    { emoji: "🌙", text: "क्या आप रात में गाड़ी चलाते हैं?", options: ["हाँ", "नहीं"], type: "single", score: [5, 15] },
    { emoji: "👁️", text: "कोई विशेष दृष्टि समस्या?", options: ["निकट दृष्टि", "दूर दृष्टि", "अस्तिग्मेटिज़्म", "कोई नहीं"], type: "multi", score: [5, 5, 5, 20] },
    { emoji: "🔍", text: "पसंदीदा लेंस प्रकार?", options: ["मानक", "ब्लू लाइट", "फोटोक्रोमिक", "प्रोग्रेसिव"], type: "single", score: [10, 15, 15, 20] },
    { emoji: "💰", text: "बजट सीमा?", options: ["₹0–₹1,000", "₹1,000–₹3,000", "₹3,000–₹7,000", "₹7,000+"], type: "single", score: [10, 15, 20, 20] },
  ];

  const tasksHi = [
    { emoji: "👀", text: "लगातार 20 बार झपकें।" },
    { emoji: "⏱️", text: "20 सेकंड के लिए स्क्रीन से दूर देखें।" },
    { emoji: "💆‍♂️", text: "1 मिनट की आँखों की मालिश करें।" },
  ];

  // Dynamic data based on language
  const currentSteps = language === "en" ? stepsEn : stepsHi;
  const questions = language === "en" ? questionsEn : questionsHi;
  const currentTasks = language === "en" ? tasksEn : tasksHi;

  // Reset answers & score when language changes
  useEffect(() => {
    setAnswers(Array(questions.length).fill(null));
    setScore(null);
  }, [language]);

  // Handle selection (supports single + multi with "None" exclusivity)
  const handleSelect = (qIndex, optionIndex) => {
    setAnswers((prev) => {
      const updated = [...prev];
      const q = questions[qIndex];
      const noneIndex = q.options.length - 1; // "None" / "कोई नहीं" is always last

      if (q.type === "multi") {
        let arr = Array.isArray(updated[qIndex]) ? [...updated[qIndex]] : [];

        if (optionIndex === noneIndex) {
          updated[qIndex] = [noneIndex];
        } else {
          if (arr.includes(optionIndex)) {
            arr = arr.filter((x) => x !== optionIndex);
          } else {
            arr = [...arr, optionIndex];
          }
          arr = arr.filter((x) => x !== noneIndex);
          updated[qIndex] = arr.length > 0 ? arr : null;
        }
      } else {
        updated[qIndex] = prev[qIndex] === optionIndex ? null : optionIndex;
      }

      return updated;
    });
  };

  // Calculate score
  const calculateScore = () => {
    let total = 0;
    questions.forEach((q, i) => {
      const ans = answers[i];
      if (ans != null) {
        if (q.type === "multi" && Array.isArray(ans)) {
          ans.forEach((idx) => {
            total += q.score[idx] || 0;
          });
        } else if (typeof ans === "number") {
          total += q.score[ans] || 0;
        }
      }
    });
    setScore(total);
  };

  // Wellness insights (bilingual)
  const getWellnessInsights = (score) => {
    if (score >= 80) {
      return {
        label: language === "en" ? "Excellent Eye Wellness" : "उत्कृष्ट आँख स्वास्थ्य",
        color: "text-green-400",
        message: language === "en" 
          ? "Your eyes are in fantastic condition! Continue your good habits."
          : "आपकी आँखें शानदार स्थिति में हैं! अच्छी आदतें जारी रखें।",
        tasks: currentTasks,
      };
    } else if (score >= 50) {
      return {
        label: language === "en" ? "Good" : "अच्छा",
        color: "text-yellow-300",
        message: language === "en"
          ? "You're doing well, but there's room for improvement."
          : "आप अच्छा कर रहे हैं, लेकिन और सुधार की गुंजाइश है।",
        tasks: currentTasks,
      };
    } else {
      return {
        label: language === "en" ? "Needs Attention" : "ध्यान देने की आवश्यकता",
        color: "text-red-400",
        message: language === "en"
          ? "Time to adopt better eye care routines."
          : "बेहतर आँख देखभाल की दिनचर्या अपनाने का समय।",
        tasks: currentTasks,
      };
    }
  };

  // Download PDF
  const downloadPDF = (score, answers, questions, chartRef, userName) => {
    if (score === null) return;

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    let y = 20;

    const sanitizeForPDF = (text = "") =>
      text
        .replace(/₹/g, "Rs.")
        .replace(/–/g, "-")
        .replace(/’/g, "'")
        .replace(/“|”/g, '"')
        .replace(/👀/g, "[Eyes]")
        .replace(/⏱️/g, "[Timer]")
        .replace(/💆‍♂️/g, "[Massage]");

    const now = new Date();
    const reportDate = now.toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });
    const reportTime = now.toLocaleTimeString("en-IN");

    // Header
    pdf.setFillColor(15, 23, 42);
    pdf.rect(0, 0, pageWidth, 40, "F");
    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(18);
    pdf.text("Eye Wellness Score Card", pageWidth / 2, 16, { align: "center" });
    pdf.setFontSize(11);
    pdf.text(`Name: ${sanitizeForPDF(userName)}`, 14, 26);
    pdf.text(`Date: ${reportDate} | Time: ${reportTime}`, pageWidth - 14, 26, { align: "right" });

    y = 50;

    // Score
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(14);
    pdf.text("Your Eye Wellness Score", pageWidth / 2, y, { align: "center" });
    pdf.setFontSize(32);
    pdf.setTextColor(234, 179, 8);
    pdf.text(`${score}/100`, pageWidth / 2, y + 16, { align: "center" });
    y += 40;

    // Quiz Summary
    pdf.setFontSize(14);
    pdf.setTextColor(2, 132, 199);
    pdf.text("Quiz Summary", 14, y);
    y += 8;

    pdf.setFontSize(11);
    pdf.setTextColor(0, 0, 0);

    questions.forEach((q, i) => {
      if (y > 270) {
        pdf.addPage();
        y = 20;
      }

      pdf.text(`${i + 1}. ${sanitizeForPDF(q.text)}`, 14, y);
      y += 6;

      const ans = answers[i];
      let answerText = "Not Answered";
      if (ans != null) {
        if (q.type === "multi" && Array.isArray(ans) && ans.length > 0) {
          answerText = ans.map((idx) => q.options[idx]).join(", ");
        } else if (typeof ans === "number") {
          answerText = q.options[ans] || "Not Answered";
        }
      }

      pdf.setTextColor(75, 85, 99);
      pdf.text(`Answer: ${sanitizeForPDF(answerText)}`, 18, y);
      y += 10;
      pdf.setTextColor(0, 0, 0);
    });

    // Eye Wellness Analysis
    if (y > 230) {
      pdf.addPage();
      y = 20;
    }

    const insight = getWellnessInsights(score);

    pdf.setFontSize(14);
    pdf.setTextColor(2, 132, 199);
    pdf.text("Eye Wellness Analysis", 14, y);
    y += 8;

    pdf.setFontSize(12);
    pdf.setTextColor(0, 0, 0);
    pdf.text(`Overall: ${sanitizeForPDF(insight.label)}`, 14, y);
    y += 6;

    pdf.setFontSize(11);
    pdf.text(sanitizeForPDF(insight.message), 14, y, { maxWidth: pageWidth - 28 });
    y += 12;

    pdf.text("Recommended Eye Care Tasks:", 14, y);
    y += 6;

    insight.tasks.forEach((task) => {
      if (y > 270) {
        pdf.addPage();
        y = 20;
      }
      pdf.text(`- ${sanitizeForPDF(task.text)}`, 16, y);
      y += 6;
    });

    y += 10;

    // Chart
    const chartCanvas = chartRef?.current?.canvas ?? chartRef?.current;
    if (chartCanvas) {
      const chartImage = chartCanvas.toDataURL("image/png");
      if (y + 160 > pdf.internal.pageSize.getHeight()) {
        pdf.addPage();
        y = 20;
      }
      pdf.addImage(chartImage, "PNG", 30, y, 150, 150);
      y += 160;
    } else {
      pdf.setFontSize(11);
      pdf.setTextColor(75, 85, 99);
      pdf.text("Graphical representation available in the app view.", 14, y);
      y += 12;
    }

    // Disclaimer & Footer
    if (y > 260) {
      pdf.addPage();
      y = 20;
    }

    pdf.setDrawColor(229, 231, 235);
    pdf.line(14, y, pageWidth - 14, y);
    y += 8;

    pdf.setFontSize(9);
    pdf.setTextColor(107, 114, 128);
    pdf.text(
      "Disclaimer: This assessment is for informational purposes only and does not replace professional medical advice. Consult an eye care specialist.",
      14,
      y,
      { maxWidth: pageWidth - 28 }
    );
    y += 18;

    pdf.setFontSize(10);
    pdf.setTextColor(15, 23, 42);
    pdf.text(
      "Powered by LensShop AI and Think5Whys Global DeepTech Solutions, Mumbai",
      pageWidth / 2,
      y,
      { align: "center" }
    );

    pdf.save("Eye-Wellness-Score-Card.pdf");
  };

  // Share score
  const shareScore = async () => {
    const cardElement = document.getElementById("scoreCard");
    if (!cardElement) return alert("Score card not rendered!");

    try {
      const canvas = await html2canvas(cardElement, { scale: 2 });
      const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));

      if (!blob) throw new Error("Failed to create image blob.");

      const file = new File([blob], "Eye-Wellness-Score.png", { type: "image/png" });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: "My Eye Wellness Score",
          text: "Here is my Eye Wellness Score! 👁️",
          files: [file],
        });
      } else {
        alert("Sharing not supported. You can download the image instead.");
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Eye-Wellness-Score.png";
        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error(err);
      alert("Error sharing score card: " + err.message);
    }
  };

  return (
    <div className='border border-cyan-300 mb-2 ml-4 mr-4'>
      <section id="personalize" className="py-2 bg-black text-white text-center px-4">
        <h2 className="text-lg lg:text-xl font-bold mb-2 text-yellow-200">
          Start Your Personalization Journey
        </h2>
        <p className="text-xs lg:text-sm mb-3 text-gray-100">
          Answer a few questions to find the perfect eyewear for you.
        </p>
        <a
          href="#engine"
          className="inline-block px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Begin Now
        </a>
      </section>

      {/* Steps */}
      <section id="engine" className="py-2 bg-black px-4">
        <h2 className="text-sm lg:text-lg text-yellow-200 font-bold text-center mb-2">
          Build Your Perfect Glasses
        </h2>

        <div className="max-w-4xl mx-auto flex flex-col gap-4 px-4">
          {currentSteps.map((step, index) => (
            <div
              key={index}
              className="p-4 bg-black border border-gray-700 rounded-lg flex items-start gap-4"
            >
              <div className="text-lg lg:text-xl border-r-4 border-blue-600 pr-4 flex items-center">
                {step.emoji}
              </div>
              <div>
                <h3 className="text-white text-xs lg:text-sm font-semibold">{step.title}</h3>
                <p className="text-white text-xs lg:text-sm">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Quiz */}
      <section className="py-2 bg-black text-center px-4">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-bold mb-4">Smart Lens Quiz</h2>
        
        <div className="flex justify-center gap-4 mb-2">
          <button
            onClick={() => setLanguage("en")}
            className={`w-16 text-xs lg:text-sm px-2 py-2 rounded ${language === "en" ? "bg-blue-600 text-white" : "bg-gray-700 text-gray-200"}`}
          >
            En
          </button>
          <button
            onClick={() => setLanguage("hi")}
            className={`w-16 text-xs lg:text-sm px-2 py-2 rounded ${language === "hi" ? "bg-blue-600 text-white" : "bg-gray-700 text-gray-200"}`}
          >
            Hi
          </button>
        </div>
        <div className="max-w-lg mx-auto flex flex-col gap-4 items-center">
          {questions.map((q, qIndex) => {
            const isAnswered = answers[qIndex] !== null && answers[qIndex] !== undefined;
            const selectedIndices = q.type === "single" 
              ? (answers[qIndex] !== null ? [answers[qIndex]] : []) 
              : (Array.isArray(answers[qIndex]) ? answers[qIndex] : []);

            return (
              <div
                key={qIndex}
                className="w-full p-4 bg-gray-900 border border-gray-700 rounded-lg flex items-start gap-4 text-white"
              >
                <div className="text-sm lg:text-lg">{q.emoji}</div>
                <div className="flex flex-col gap-2 text-left flex-1">
                  <h3 className="text-xs lg:text-sm font-semibold text-cyan-200">{q.text}</h3>
                  <div className="flex flex-wrap gap-2">
                    {q.options.map((opt, optIndex) => {
                      const isSelected = selectedIndices.includes(optIndex);

                      return (
                        <button
                          key={optIndex}
                          onClick={() => handleSelect(qIndex, optIndex)}
                          className={`
                            px-3 py-1 text-xs lg:text-sm rounded-md border transition text-white font-medium
                            ${isSelected 
                              ? "bg-blue-600 border-blue-500 hover:bg-blue-700 shadow-sm" 
                              : "bg-gray-700 border-gray-600 hover:bg-gray-600"
                            }
                          `}
                          aria-pressed={isSelected}
                        >
                          {opt}
                        </button>
                      );
                    })}
                  </div>
                  {/* Optional subtle indicator if question is unanswered */}
                  {!isAnswered && (
                    <p className="text-xs text-gray-500 mt-1">Not answered yet</p>
                  )}
                </div>
              </div>
            );
          })}

          <button
            onClick={calculateScore}
            className="text-sm lg:text-lg mt-2 px-2 lg:px-6 py-3 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
          >
            Submit Quiz
          </button>
        </div>

        {score !== null && (
          <div id="scoreCard" className="mt-8 px-4 text-center max-w-xl mx-auto">
            {(() => {
              const insight = getWellnessInsights(score);
              return (
                <>
                  <h2 className="text-lg lg:text-xl text-yellow-200 font-bold mb-2">
                    Your Eye Wellness Score
                  </h2>

                  <div className={`text-xl lg:text-2xl font-bold mb-1 ${insight.color}`}>
                    {score}/100
                  </div>

                  <p className="text-sm lg:text-lg text-white font-semibold mb-1">
                    {insight.label}
                  </p>

                  <p className="text-sm lg:text-base text-white mb-4">
                    {insight.message}
                  </p>

                  <div className="max-w-md mx-auto flex flex-col gap-2">
                    {insight.tasks.map((task, index) => (
                      <div
                        key={index}
                        className="p-2 bg-gray-900 border border-gray-700 rounded-lg flex items-center gap-3 text-white text-sm lg:text-base"
                      >
                        <span className="text-xl lg:text-2xl">{task.emoji}</span>
                        <span>{task.text}</span>
                      </div>
                    ))}
                  </div>
                </>
              );
            })()}
          </div>
        )}
      </section>

      {/* Score with chart & actions */}
      {score !== null && (
        <section className="mt-6 text-center px-4">
          <h2 className="text-lg lg:text-xl text-yellow-200 font-bold mb-3">
            Your Eye Wellness Score
          </h2>

          <ScoreChart score={score} chartRef={chartRef} />

          <p className="text-cyan-400 mt-4 mb-3">
            Personalized recommendations for you:
          </p>

          <ul className="max-w-md mx-auto space-y-2 text-sm lg:text-base text-white">
            <li className='text-white'>🖥️ Follow the 20-20-20 rule for screens</li>
            <li className='text-white'>🕶️ Use UV-protected lenses outdoors</li>
            <li className='text-white'>👁️ Schedule regular eye check-ups</li>
          </ul>

          <div className="flex justify-center gap-4 mt-5">
            <button
              onClick={() => downloadPDF(score, answers, questions, chartRef, userName)}
              className="w-40 lg:w-48 text-sm lg:text-sm px-2 py-2 bg-blue-600 rounded-md text-white hover:bg-blue-700"
            >
              📄 Download Report
            </button>

            <button
              onClick={shareScore}
              className="w-40 lg:w-48 px-2 py-2 bg-gray-700 rounded-md text-white text-sm lg:text-sm hover:bg-gray-600"
            >
              🔗 Share
            </button>
          </div>
        </section>
      )}

      <VisionProfile />

      <section className="py-2 text-center bg-black">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-bold mb-1">
          Daily Eye Fitness Routine
        </h2>
        <p className="text-sm lg:text-lg text-cyan-400 mb-2">
          Complete these tasks to earn rewards!
        </p>

        <div className="max-w-lg mx-auto flex flex-col gap-2">
          {currentTasks.map((task, index) => (
            <div
              key={index}
              className="p-2 text-sm lg:text-lg bg-gray-700 text-white border rounded-lg flex items-center gap-3"
            >
              <span className="text-xl lg:text-2xl">{task.emoji}</span>
              <span className='text-sm lg:text-lg'>{task.text}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

const Features = () => {
  const [email, setEmail] = useState('');

  const handleContact = () => {
    // Placeholder for API call, e.g., axios.post('/api/contact', { email })
    // console.log('Contact email:', email);
    // Reset input after submission (optional)
    setEmail('');
  };

  const features = [
    { title: "Face Detection", desc: "AI-powered face shape analysis for the perfect fit.", emoji: "🤖" },
    { title: "Smart Mirror", desc: "Visualize glasses on your face in real-time.", emoji: "🪞" },
    { title: "Eye Health Score", desc: "Track and improve your vision wellness.", emoji: "👁️" },
    { title: "Group Try-On", desc: "Try on glasses with friends virtually.", emoji: "👥" },
    { title: "Lens AI", desc: "Smart lens recommendations for your needs.", emoji: "🔍" },
    { title: "Offline Sync", desc: "Access your profile anywhere, anytime.", emoji: "📡" },
  ];

  // Features array derived from your TopNav
  const moreFeatures = [
    { title: "Eyewear Routine", emoji: "🧿", desc: "Track your eyewear usage and routine." },
    { title: "beSure Quality", emoji: "🛡️", desc: "Assured quality for all your lenses and frames." },
    { title: "World of Lenses", emoji: "🌍", desc: "Explore a variety of lenses for your needs." },
    { title: "World of Frames", emoji: "👓", desc: "Discover stylish frames to suit your style." },
    { title: "Essentials", emoji: "🧩", desc: "Everyday eyewear essentials and accessories." },
    { title: "Nearby", emoji: "📍", desc: "Find stores and services near you." },
    { title: "boloGrahak", emoji: "🛟", desc: "Connect and communicate with our customer care." },
    { title: "My Packet", emoji: "🚛", desc: "Track your shipments and orders easily." },
    { title: "Personalize", emoji: "🎨", desc: "Customize your eyewear experience." },
    { title: "LensShop Twin", emoji: "🌐", desc: "Try virtual eyewear using our twin app." },
    { title: "Win Photo Smart", emoji: "😎", desc: "Participate in contests and win prizes." },
    { title: "KharchoJeeto", emoji: "🪞", desc: "Smart ways to earn and save with your eyewear purchases." },
    { title: "Digital Income", emoji: "💰", desc: "Boost your income with our digital platform." },
    { title: "Monthly EyeGyan", emoji: "📖", desc: "Stay updated with our monthly eye care tips." },
    { title: "More", emoji: "⋯", desc: "See more options and services." },
  ];


  const usps = [
    { emoji: "🤖", label: "AI-Powered Personalization" },
    { emoji: "🔄", label: "Hassle-Free Returns" },
    { emoji: "🚀", label: "Fast Global Shipping" },
    { emoji: "💰", label: "Affordable Pricing" },
  ];

  return (
    <div className='border border-cyan-400 ml-4 mr-4'>
      <section id="features" className="py-2 bg-black max-w-6xl mx-auto px-4">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-bold text-center mb-1 mt-2">
          Why Choose Us?
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-2 bg-black border rounded-lg text-center flex flex-col items-center gap-2"
            >
              <span className="text-lg lg:text-xl">{feature.emoji}</span> {/* Emoji replaces img */}
              <h3 className="text-sm lg:text-lg text-cyan-400 font-semibold mb-2">
                {feature.title}
              </h3>
              <p className="text-white text-xs lg:text-sm">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="more-features" className="py-2 bg-black max-w-6xl mx-auto px-4">
        <h2 className="text-lg lg:text-xl text-cyan-400 font-bold text-center mb-2 mt-2">
          More Reasons to Choose Us!!
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
          {moreFeatures.map((feature, index) => (
            <div
              key={index}
              className="p-2 bg-black border rounded-lg text-center flex flex-col items-center gap-2"
            >
              <span className="text-lg lg:text-xl">{feature.emoji}</span>
              <h3 className="text-sm lg:text-lg text-cyan-400 font-semibold mb-2">
                {feature.title}
              </h3>
              <p className="text-white text-xs lg:text-sm">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-2 bg-black">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-bold text-center mb-2">
          What Makes Us Different
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto px-4">
          {usps.map((usp, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center p-4 text-white bg-gray-800 border rounded-lg text-center gap-2"
            >
              <span className="text-sm lg:text-lg">{usp.emoji}</span>
              <span className="text-xs lg:text-sm font-semibold">{usp.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="py-2 bg-black max-w-4xl mx-auto px-4 flex flex-col justify-center items-center">
        <textarea
          placeholder="Write to Us"
          className="p-3 w-full h-[200px] text-lg text-white rounded-md focus:outline-none focus:ring-2 focus:ring-blue-600 resize-none"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          className="mt-2 px-2 py-2 bg-blue-600 text-lg text-white rounded-md md:rounded-r-md hover:bg-blue-700 transition-colors"
          onClick={handleContact}
        >
            <span className="text-lg mr-2">✉️</span>Contact
        </button>
      </section>
    </div>    
  );
};

const Footer = () => {
  return (
    <footer className="bg-black text-white py-2 text-center">
      <div className="flex justify-center gap-6 mb-2">
        <a href="#home" className="hover:text-blue-400 text-yellow-200">Home</a>
        <a href="#support" className="hover:text-blue-400 text-yellow-200">Support</a>
        <a href="#terms" className="hover:text-blue-400 text-yellow-200">Terms</a>
        <a href="#privacy" className="hover:text-blue-400 text-yellow-200">Privacy</a>
      </div>
      <p className="mt-4">© 2026 LensShop AI Platform powered by Think5Whys.</p>
    </footer>
  );
};

const LensShopHome = () => {
  return (
    <div className='bg-black'>
      <Navbar />
      <TopNav />
      <Hero />
      <PersonalizationPreview />
      <Features />
      <Footer />
    </div>
  );
};

export default LensShopHome;